module.exports = {
          srcSet: __webpack_public_path__ + "images/1948-517a87fc4ddcaa8dd87be0aa9a2054e3-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1948-9bc948ce0e0337f6bba85d9760cd9658-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1948-517a87fc4ddcaa8dd87be0aa9a2054e3-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1948-9bc948ce0e0337f6bba85d9760cd9658-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1948-517a87fc4ddcaa8dd87be0aa9a2054e3-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1948-517a87fc4ddcaa8dd87be0aa9a2054e3-320.jpg"},
          
          width: 320,
          height: 251
        }